<template>
    <div>
        <h2 v-if="heading && heading.length>0" class="d-none d-sm-block d-lg-inline-block">{{ heading }}</h2>
        <b-nav class="pt-0 breadcrumb-container d-none d-sm-block d-lg-inline-block">
            <b-breadcrumb :items="items"/>
        </b-nav>
    </div>
</template>

<script>
    export default {
        props: ['heading'],
        data() {
            return {
                items: [],
                appMode: localStorage.getItem('appMode') || "hms",
            }
        },
        methods: {
            getUrl(path, sub, index) {
                var pathToGo = '/' + path.split(sub)[0] + sub
                if (pathToGo === '/app') {
                    pathToGo = '/'
                }
                return pathToGo
            }
        },
        mounted() {
            let path = this.$route.path.substr(1)
            let rawPaths = path.split('/')
            rawPaths.shift();

            for (var pName in this.$route.params) {
                if (rawPaths.includes(this.$route.params[pName])) {
                    rawPaths = rawPaths.filter(x => x !== this.$route.params[pName])
                }
            }

            rawPaths.map((sub, index) => {
                this.items.push({
                    text: this.$t(sub === '' ? this.appMode +  '.dashboard' : this.appMode +  '.' + sub),
                })
            })
        }
    }
</script>
